module.exports = __webpack_public_path__ + "static/img/introduce_15.71deee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_15.png
// module id = /Jo7
// module chunks = 1